/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Tab_RecentInputs */

const en_directory_home_board_tab_recent = /** @type {(inputs: Directory_Home_Board_Tab_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent`)
};

const zh_directory_home_board_tab_recent = /** @type {(inputs: Directory_Home_Board_Tab_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新`)
};

/**
* | output |
* | --- |
* | "Recent" |
*
* @param {Directory_Home_Board_Tab_RecentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_tab_recent = /** @type {((inputs?: Directory_Home_Board_Tab_RecentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Tab_RecentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_tab_recent(inputs)
	return zh_directory_home_board_tab_recent(inputs)
});
export { directory_home_board_tab_recent as "directory.home.board.tab_recent" }